export const heading =
  /^ {0,3}(#{1,6})(?=\s*|$)(.*?)(?:\s+(\[[a-zA-Z\d:-]+\]))?(?:\n+|$)/
